<template>
  <div :class="bem()">
    <div :class="bem('icon')">
      <VisionIcon id="package" icon="package" size="stretch" gradient="default"/>
    </div>
    <span :class="bem('text')"><span :class="bem('highlight')">30 Day</span> Returns</span>

    <ToolTip
      :class="bem('tooltip')"
      arrow-position="left"
      content="Not quite sure? We offer returns for up to 30 days, so you can find the pairs you love."
      icon-height="16px"
    />
  </div>
</template>

<script setup>
const bem = useBEM('ReturnsConvincer')
</script>

<style lang="postcss" scoped>
.ReturnsConvincer {
  @apply flex items-center gap-x-2
    w-full;
}

.ReturnsConvincer__icon {
  @apply w-5 h-5 lg:w-6 lg:h-6 flex justify-center lgMax:mx-[2px];
}

.ReturnsConvincer__tooltip {
  @apply ml-auto;
}

.ReturnsConvincer__text {
  @apply text-sm font-medium;
}

.ReturnsConvincer__highlight {
  @apply t-gradient;
}

.ReturnsConvincer__tooltip {
  @apply ml-auto;
}
</style>